/**
 * Вкладки, превращающиеся в аккордеоны на низких разрешениях экрана
 */

/**
 * Состояние, в котором работает элемент
 */
const TAC_STATE = {
  // аккордеон
  ACCORDEON: 0,
  // табы
  TABS: 1
};

class Tac {

  constructor() {
    this.tacs = document.querySelectorAll('.tac');
    // ничего не делаем, если элементов на странице нет
    if (this.tacs.length > 0) {
      this.init()
    }
  }

  /**
   * Возвращает, в каком состоянии работает элемент
   */
  getState() {
    const test = document.querySelector('.tac__tabs');
    // показываются ли табы на странице
    // depending on tabs visibility in current screen resolution    
    return (
      (window.getComputedStyle(test, null).getPropertyValue("display") === 'none') ? 
      TAC_STATE.ACCORDEON:
      TAC_STATE.TABS
    )
  }

  init() {
    const state= this.getState();
    // init tabs or accordions
    this.tacs.forEach((tac) => {
      if (state == TAC_STATE.ACCORDEON) {
        this.initAccs(tac)
      }
      else {
        this.initTabs(tac)        
      }
    })
  }


  initTabs(tac) {

    const triggers = tac.querySelectorAll('.tac__link');
    
    triggers.forEach((trigger, index) => {

      const target = trigger.getAttribute('data-target');
      const panel = tac.querySelector(target);
      const tab = trigger.parentNode;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();	  

        if (panel.classList.contains('tac__panel--active')) return;
        this.deactivateAllTabs(tac);
        this.activateTab(tab);
        this.activatePanel(panel);
      });

      // set initial state when first tab is selected
      if (index==0) {
        this.activateTab(tab);
        this.activatePanel(panel);
      }
      
    })

  }


  initAccs(tac) {

    const triggers = tac.querySelectorAll('.tac__acc');
    
    triggers.forEach((trigger) => {

      const target = trigger.getAttribute('data-target');
      const panel = tac.querySelector(target);

      trigger.addEventListener('click', (e) => {
        e.preventDefault();	  

        if (panel.classList.contains('tac__panel--active')) {
          this.deactivateAcc(trigger);
          this.deactivatePanel(panel);
        }
        else {
          this.activateAcc(trigger);
          this.activatePanel(panel);
        }
      });
      
    })

  }


  activateTab(tab) {
    tab.classList.add('tac__tab--active');            
  }

  activateAcc(acc) {
    acc.classList.add('tac__acc--active');            
  }

  activatePanel(panel) {
    panel.classList.add('tac__panel--active');            
  }

  deactivateTab(tab) {
    tab.classList.remove('tac__tab--active');            
  }

  deactivateAcc(acc) {
    acc.classList.remove('tac__acc--active');            
  }

  deactivatePanel(panel) {
    panel.classList.remove('tac__panel--active');            
  }

  deactivateAllTabs(tac) {
    const tabs = tac.querySelectorAll('.tac__tab');
    const panels = tac.querySelectorAll('.tac__panel');
    tabs.forEach(tab => this.deactivateTab(tab))
    panels.forEach(panel => this.deactivatePanel(panel))
  }

  deactivateAllAccs(tac) {
    const accs = tac.querySelectorAll('.tac__acc');
    const panels = tac.querySelectorAll('.tac__panel');
    accs.forEach(acc => this.deactivateAcc(acc))
    panels.forEach(panel => this.deactivatePanel(panel))
  }

}


export default Tac;




